/**
 * created by yxxyyxyx
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Input, Tabs,Slider} from 'antd';
import TableComponents from "../../components/TableComponents";
import BaseComponent from "../../../../base/BaseComponent";
import {TitleIcon} from "../../../components/customTable/CustomTable";
import Btn from "../../components/btn/Btn";
import {formatDate} from '../../../../utils'
import request from "../../../../base/request";
import {setInfoToLocalStorage} from "../../../../actions";

const { TabPane } = Tabs;
const {Search} = Input;
export default class Solicitation extends BaseComponent {
    static defaultProps = {};
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {
            activeKey:"全部",
            record:{},
            searchText:'',
            dataSource:[],
            start:1,
            size:10,
            count:0,
            status:true,
        }
    }

    componentWillMount() {
    }
    sysConfigLoadOver() {
        let roleCodes=window.top.currentUser.roleCodes;
        let role= "ces001";
        if(roleCodes.indexOf(role)>-1){
           this.setState({status:true})
        }else{
            this.setState({status:false})
        }
        this.getList()
    }
    componentDidMount() {
    }

    customRender() {
        return (
            <div style={{padding:'20px'}}>
                 {/*渲染table*/}
                 {this.renderTabList()}
                 {/*选择按钮 比如：新增 搜索 */}
                 <div style={{width:'100%',}}>
                     {this.renderBtnList()}
                 </div>
                {/*渲染数据*/}
                {this.renderData()}

            </div>
        )
    }
    // -------------tablist
    //tabList 的渲染
    renderTabList(){
        let TableList;
        if(this.state.status) {
            TableList = this.sysConfig.TableList1||[];
        }else{
            TableList = this.sysConfig.TableList2||[];
        }

        return(
            <Tabs activeKey={this.state.activeKey}  onChange={this.changeTable}>
                {
                    TableList&&TableList.length&&TableList.map((item,index)=>{
                        return(<TabPane tab={item.title} key={item.key}></TabPane>
                        )})}

            </Tabs>
        )

    }
    changeTable=(key)=>{
        this.setState({activeKey:key,start:1},()=>{
            this.getList()
        })

    };


    //-----------------新增 以及搜索
    //功能渲染
    renderBtnList(){
        let addBtn = this.sysConfig.addBtn||null;
        let searchObj = this.sysConfig.searchObj ||null;
            return (<div style={{padding:'20px 0px',display:'flex',justifyContent: "space-between",marginRight:'20px',alignItems: "center"}}>
               {addBtn&&this.state.status? <div><Btn btnList={addBtn} currentState={this.state} record={this.state.record}
                           refresh={() => this.refresh()}/></div>:''
                }
                <div style={{marginTop:'5px'}}>
                    {searchObj&&searchObj.expression?<Search placeholder={searchObj.placeholder}  value={this.state.searchText}
                                                             onChange={(e) => {
                                                                 this.setState({searchText: e.target.value},)
                                                             }} onSearch={(v) => this.onSearch(v)}
                                                             style={{width: "200px"}}/>:''}
                </div>
            </div>)
    }

    //顶部搜索
    onSearch(v) {
        this.setState({searchText:v,start:1},()=>{
            this.getList()
        });
    }
    //选人数据
    renderData(){
        let data =this.state.dataSource;
        let roleCodes=window.top.currentUser.roleCodes;
        let role= "ces001";
        let columns=this.sysConfig.columns||[];
        let btnList =this.sysConfig.btnList||[];
        let btnList1 =this.sysConfig.btnList2||[];
        let statusColor = this.sysConfig.statusColor||{};
        let newColumns=[];
        columns&&columns.length&&columns.forEach((item,index)=>{

            if(item.key==="btnList"){
                newColumns.push({
                    title: item.title,
                    //dataIndex: item.key,
                    key: item.key,
                    render: (text, record, index) => {
                        return (<div><Btn btnList={eval(item.expression)?btnList:btnList1} currentState={this.state} record={record} refresh={() => this.refresh()}/></div>
                        )
                    }
                })
            }else if(item.key==='receiverObjs'&&eval(item.expression)){
                newColumns.push({
                    title: item.title,
                    dataIndex: item.key,
                    key: item.key,
                    render: (text, record, index) => {
                        let array =text;
                        let newArray =[];
                        array&&array.forEach((item)=>{
                           if(item.receiver){
                                   newArray.push(item.receiver.name+"("+item.status+")")
                           }
                        });
                        return (
                           <div>{newArray.join(',')}</div>
                        )
                    }
                })
            }
            else if(item.key==='replyDate' ){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    render: (text, record, index) => {
                        return (
                            <div>{formatDate( eval(item.expression)?record.replyDate:record.appointmentObj.replyDate)}</div>
                        )
                    }
                })
            }
            else if(item.key==='requireContent'){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    width:item.width,
                    render: (text, record, index) => {
                        return (
                            <div>{ eval(item.expression)?<div>{record.requireContent}</div>:<div>{record.appointmentObj.requireContent}</div>}</div>
                        )
                    }
                })
            }
             else if(item.key==='solicitors'){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    render: (text, record, index) => {
                        let username;
                        if(eval(item.expression)){
                           if(record.publisher&&record.publisher.userName){
                               username = record.publisher.userName
                           }
                        }else{
                            if(record.appointmentObj&&record.appointmentObj.publisher&&record.appointmentObj.publisher.userName){
                                username = record.appointmentObj.publisher.userName
                            }
                        }
                        return (
                            <div>{username==={}?'姚小妍':username}</div>
                        )
                    }
                })
            }
            else if(item.key==='status'){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    width:item.width,
                    dataIndex: item.key,
                    render: (text, record, index) => {
                        let color ;
                        statusColor&&statusColor.forEach((item)=>{
                          if(item.statusName ===text){
                              color = item.color
                          }
                        });
                        return (
                            <div><span style={{width:'8px',height:'8px',borderRadius:'50%',background:color,display: "inline-block",marginRight:'8px'}}></span><span>{text}</span></div>
                        )
                    }
                })
            }
            else{
                if(eval(item.expression)){
                    newColumns.push(item)
                }
            }
        })
        return(
            <div>
                {this.sysConfig&&<TableComponents btnList={btnList}
                                                  dataSource={data}
                                                  columns={newColumns}
                                                  start={this.state.start}
                                                  size={this.state.size}
                                                  count={this.state.count}
                                                  onChange={(page, pageSize)=>{
                                                      this.state.start = page
                                                      this.state.size =pageSize
                                                      this.setState({},()=>{
                                                          this.getList()
                                                      })
                                                  }}
                ></TableComponents>}
            </div>

        )
    }
    //刷新
    refresh() {
        this.getList()
    }

    //获取列表
    getList() {
        let body = {};
        let params = [];
        let requestInformation;
       if(this.state.status){
          requestInformation= this.sysConfig.requestInformation1 || ""
       }else{
          requestInformation= this.sysConfig.requestInformation2 || ""
       }
        let listUrl = requestInformation.listUrl  || "";
        let requestMethod = requestInformation.requestMethod  || "post";
        let storyTypeKey = requestInformation.requestShowRefKey  || "showRef";
        let storyTypeVal = requestInformation.requestShowRefVal  ;
        let keywordParam =requestInformation.keywordParam||"keyword";
        let keywordTypeKey = requestInformation.requestKeywordRefKey  || "keywordFiled";
        let keywordTypeVal = requestInformation.requestKeywordRefVal  ;

        let smallTabParam = requestInformation.smallTabParam ;
        smallTabParam.val = this.state.activeKey;

        params.push(smallTabParam);


        let requestStartParam = requestInformation.requestStartParam  || "num";
        let requestSizeParam = requestInformation.requestSizeParam  || "size";

        body[keywordTypeKey]=keywordTypeVal;
        body[requestStartParam] = this.state.start;
        body[keywordParam] =this.state.searchText;
        body[requestSizeParam] = this.state.size;
        if(this.state.activeKey!=='全部'){
            body.params = params;
        }
        body[storyTypeKey] = storyTypeVal;
        request({url:listUrl, contentType:"json", body,  method:requestMethod, callBack:(data)=>{
                this.setState({dataSource:data.list,count:data.count})
            }});
    }


}
